import React, { useState } from 'react';
import chair from '../../../assets/images/chair.png';
import { DayPicker } from 'react-day-picker';
import { format } from 'date-fns';

const AppointmentBanner = ({selectedDate,setSelectedDate}) => {
    
    return (
        <div>
            <div className="hero my-10">
                <div className="hero-content flex-col lg:flex-row-reverse justify-between">
                    <img src={chair} alt='dental chair' className=" rounded-lg lg:w-1/2 shadow-2xl" />
                    <div className='p-10  mr-10'>
                    <DayPicker
                    mode='single'
                    selected={selectedDate}
                    onSelect={setSelectedDate}

                     />
                     <p>You have selected date:{format(selectedDate,'PP')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppointmentBanner;